import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { usePageInfo } from 'providers/PageInfoProvider'

import { setPlanAdditionsAction } from 'modules/payment/redux/actions/common'

import { PLAN_ADDITIONS_MAP } from 'root-constants/common'

export const useSetPlanAdditions = (): void => {
  const { currentPageId } = usePageInfo()
  const dispatch = useDispatch()

  useEffect(() => {
    const planAdditions = PLAN_ADDITIONS_MAP[currentPageId]

    if (planAdditions) {
      dispatch(setPlanAdditionsAction(planAdditions))
    }
  }, [dispatch, currentPageId])
}
